import { useAuthStore } from '../stores/authStore.js';

export const useAuth = () => {
  const {
    userId,
    outletId,
    outletName,
    userName,
    accessType,
    phone,
    menuId,
    menuItems,
    isAuthenticated,
    isLoading,
    isInitialized,
    login,
    logout,
    checkAuth,
  } = useAuthStore();

  return {
    userId,
    outletId,
    outletName,
    userName,
    accessType,
    phone,
    menuId,
    menuItems,
    isAuthenticated,
    isLoading,
    isInitialized,
    login,
    logout,
    checkAuth,
  };
};
